// Table component styling
const table = {
  styleOverrides: {
    root: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: '0.875rem',
      borderRadius: '4px',
    },
  },
};

// TableHead component styling
const tableHead = {
  styleOverrides: {
    root: {
      "& .MuiTableCell-head": {
        fontWeight: 600,
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontSize: '0.875rem',
      },
    },
  },
};

// TableCell component styling
const tableCell = {
  styleOverrides: {
    root: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: '0.8125rem',
      padding: '10px 16px',
    },
    head: {
      fontWeight: 600,
      fontSize: '0.8125rem',
    },
  },
};

// TableContainer component styling
const tableContainer = {
  styleOverrides: {
    root: {
      borderRadius: '4px',
    },
  },
};

export { table, tableHead, tableCell, tableContainer };
